module.exports = __webpack_public_path__ + "img/bikkurapon_target_taiwan.1137ae69.png";